import {
  Vue, Component,
} from 'vue-property-decorator';
import style from './index.module.scss';

@Component({ name: 'LandPageNoLogo' })
export default class LandPageNoLogo extends Vue {
  private redirectApp() {
    this.$emit('redirectApp');
  }

  private render() {
    return (
      <div class={style['no-logo']}>
            <div
              class={style['download-button']}
              onClick={this.redirectApp.bind(this)}
            >下载APP申请额度</div>
        </div>
    );
  }
}
